import * as actions from "./actionsTypes";

const initialData = {
  loading: false,
  loadingById: false,
  saveLoading: false,
 requestTrackingsLength: 0,
 requestTrackings: [],
 requestTracking: {},
 requestTrackingError: "",
  formError: "",
};

export default function RequestTrackingReducer(state = initialData,action) {
  switch (action.type) {
    case actions.LOADING_REQUEST_TRACKING:
      return { ...state, loading: action.payload };
    case actions.LOADING_REQUEST_TRACKING_BY_ID:
      return { ...state, loadingById: action.payload };
    case actions.SAVE_LOADING_REQUEST_TRACKING:
      return { ...state, saveLoading: action.payload };
    case actions.GET_REQUEST_TRACKING:
      return {
        ...state,
       requestTrackings: action.payload.requestTrackings,
       requestTrackingsLength: action.payload.requestTrackingsLength,
      };
    case actions.GET_REQUEST_TRACKING_BY_ID:
      return {
        ...state,requestTracking: action.payload
      };
    case actions.FORM_FAIL:
      return { ...state, formError: action.payload };
    case actions.REQUEST_TRACKING_FAIL:
      return { ...state,requestTrackingError: action.payload };
    default:
      return state;
  }
}
